<template>
  <div
    class="
      set-password-container
      logged-out-container
      p-d-flex p-flex-column p-jc-center p-ai-center
    "
  >
    <div class="logged-out-form">
      <h1>Welcome</h1>
      <h2>Please set your password.</h2>
      <div class="form-container">
        <div class="p-field">
          <label for="new_password">Password</label>
          <Password
            id="new_password"
            :feedback="true"
            v-model="newPassword"
            autocapitalize="none"
            autocorrect="off"
            spellcheck="false"
            autocomplete="off"
          />
        </div>
        <Button @click="onSubmitClick" label="Log In" />
      </div>
      <img
        class="annum-logo"
        alt="Annum logo"
        src="@/assets/logo-global.jpeg"
        width="126"
        height="54"
      />
    </div>
  </div>
</template>

<script lang="ts">
// Route for testing: /set-password/1234567890/?accountId=123&planId=456&route=plan

import Vue from 'vue'
import Password from 'primevue/password'
import Button from 'primevue/button'
import {AlertMessageSeverity} from '@/models/AlertMessage'

Vue.component('Password', Password)
Vue.component('Button', Button)

export default Vue.extend({
  name: 'PasswordSet',
  data: () => {
    return {
      newPassword: '' as string,
      isOnboardingFlow: false as boolean,
      isPlanFlow: false as boolean,
      accountId: null as string | null,
      planId: null as string | null,
      redirectRoute: null as string | null,
    }
  },
  computed: {
    isFormValid: function () {
      if (this.newPassword != '') {
        return true
      }
      return false
    },
  },
  created: function () {
    if (!this.$route.params.token) {
      this.$router.push('/sign-in')
    }else if(this.$route.query.accountId && this.$route.query.planId && this.$route.query.route){
      this.isOnboardingFlow = this.$route.query.route === 'onboarding' ? true : false
      this.isPlanFlow = this.$route.query.route === 'plan' ? true : false
      this.accountId = this.$route.query.accountId as string
      this.planId = this.$route.query.planId as string
    }
  },
  methods: {
    onSubmitClick: function () {
      if (!this.isFormValid) {
        Vue.prototype.$toast.add({
          severity: AlertMessageSeverity.error,
          summary: 'Please complete all fields.',
          life: 3000,
        })
        return
      }

      this.$store.getters.services.users
        .setPassword(this.$route.params.token, this.newPassword)
        .then(
          (initialResponseObj) => {
            if(this.isPlanFlow){
              // Set plan ID so that correct plan loads when re-routing to calendar view
              this.$store.commit('updateCurrentPlanIntID', Number(this.planId))
            }
            this.$store
              .dispatch('logInWithInitialResponse', initialResponseObj)
              .finally(() => {
                if(this.isOnboardingFlow){
                  this.$router.push(`/setup/full/${this.accountId}/${this.planId}/`)
                }else if(this.isPlanFlow){
                  this.$router.push(`/account/${this.accountId}/plan/${this.planId}/calendar/month`)
                }else{
                  this.$router.push('/') 
                }
                Vue.prototype.$toast.add({
                  severity: AlertMessageSeverity.success,
                  summary: 'Password saved.',
                  life: 3000,
                })
              })
          },
          (error) => {
            this.$store.getters.services.authentication.logout()
            Vue.prototype.$toast.add({
              severity: AlertMessageSeverity.error,
              summary:
                'Error saving password. Please visit the link you received via email again.',
              life: 3000,
            })
          }
        )
    },
  },
})
</script>

<style lang="scss">
@import '@/styles/_imports.scss';

.set-password-container {
  .logged-out-form {
    max-width: 50rem;
  }
  h1 {
    @include font-normal;
    font-size: 4rem;
    margin-bottom: 2rem;
  }
  h2 {
    @include font-light;
    font-size: 2rem;
    margin-bottom: 4rem;
  }
  .p-password {
    padding-bottom: 4rem;
  }
  .p-button {
    margin-bottom: 8rem;
  }
  .annum-logo {
    max-width: 15rem;
  }
  button {
    font-size: 1.5rem;
  }
}
</style>